import React, { Component } from "react";

export class TestEnvironmentBanner extends Component {
	static displayName = TestEnvironmentBanner.name;

	isTestEnvironment() {
		const hostname = window.location.hostname;
		return hostname === "testimats.conferencetech.com" || hostname === "localhost";
	}

	render() {
		if (!this.isTestEnvironment()) {
			return null;
		}

		return (
			<div
				style={{
					backgroundColor: "#ff9800",
					color: "#000",
					padding: "8px",
					textAlign: "center",
					fontWeight: "bold",
					fontSize: "14px",
					width: "100%",
					position: "sticky",
					top: 0,
					zIndex: 1050,
					boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
				}}
			>
				⚠️ This is a test website but is still connected to the production database.{" "}
				<a
					href="https://imats.conferencetech.com/"
					target="_blank"
					rel="noopener noreferrer"
					style={{
						color: "#000",
						textDecoration: "underline",
						fontWeight: "bold"
					}}
				>
					Go to Production Site
				</a>
			</div>
		);
	}
}

